import i18n from '@/lang/i18n'
import { AgGridColumnType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-enterprise/all-modules'

export const clinicalSearchPatientModalGridMasterColumnDefs =
    (): (ColDef | ExportedColDef | ExportedColGroupDef)[] => [
        { type: AgGridColumnType.MASTER_DETAIL },
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('global.name'),
            field: 'patName',
            type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING
        },
        {
            headerName: i18n.tc('grid.patMiddleName'),
            field: 'patMiddleName',
            type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING
        },
        {
            headerName: i18n.tc('global.surname1'),
            field: 'patSurname1',
            type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING
        },
        {
            headerName: i18n.tc('global.surname2'),
            field: 'patSurname2',
            type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING
        },
        {
            headerName: 'NHC',
            field: 'centerIdentifier',
            type: AgGridColumnType.TEXT
        },
        {
            headerName: i18n.tc('global.gender'),
            field: 'genderName',
            type: AgGridColumnType.DIACRITICS_INSENSITIVE_TEXT_FOR_CODE_DESCRIPTION_OR_STRING
        },
        {
            headerName: i18n.tc('global.birthday'),
            field: 'patBirthdate',
            type: AgGridColumnType.DATE,
            width: 120,
            suppressSizeToFit: true
        }
    ]
